import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(VContainer,[_c(VRow,{attrs:{"align":"center"}},[(_vm.icon)?_c(VCol,{attrs:{"cols":"1"}},[_vm._t("icon")],2):_vm._e(),_c(VCol,{staticClass:"font-weight-regular",attrs:{"cols":"5"}},[_vm._t("label")],2),_c(VCol,{staticClass:"font-weight-medium subtitle-1",attrs:{"cols":"6"}},[_vm._t("text")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }